import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";
import * as React from "react";

export const ActiveClockIcon = (props: SvgIconProps) => {
    const { viewBox = "0 0 20 20", ...rest } = props;

    return (
        <SvgIcon viewBox={viewBox} {...rest}>
            <g>
                <g>
                    <rect fill="none" width="20" height="20" />
                    <path
                        fill="none"
                        stroke="#e35afc"
                        strokeMiterlimit="10"
                        strokeWidth="1.24px"
                        d="M14.18,16.55a7.25,7.25,0,1,1,3.22-6,7.21,7.21,0,0,1-1.48,4.39"
                    />
                    <line
                        fill="none"
                        stroke="#e35afc"
                        strokeMiterlimit="10"
                        strokeWidth="1.2px"
                        x1="12.4"
                        y1="8.93"
                        x2="9.82"
                        y2="11.24"
                    />
                    <line
                        fill="none"
                        stroke="#e35afc"
                        strokeMiterlimit="10"
                        strokeWidth="1.24px"
                        x1="10.3"
                        y1="2.89"
                        x2="10.3"
                        y2="1.4"
                    />
                    <line
                        fill="none"
                        stroke="#e35afc"
                        strokeMiterlimit="10"
                        strokeWidth="1.24px"
                        x1="15.32"
                        y1="2.73"
                        x2="17.79"
                        y2="5.48"
                    />
                    <line
                        fill="none"
                        stroke="#e35afc"
                        strokeMiterlimit="10"
                        strokeWidth="1.24px"
                        x1="4.68"
                        y1="2.89"
                        x2="2.21"
                        y2="5.64"
                    />
                </g>
            </g>
        </SvgIcon>
    );
};
